import React from 'react';
import styled from 'styled-components/macro';
import { Badges, Badge, PanelHeadline } from '@tovia/man-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/pro-regular-svg-icons';
import { faFilm } from '@fortawesome/pro-duotone-svg-icons';
import { ImageDetailsPanel } from '../../components/panels/ImageDetailsPanel';
import { NavOrExternalLink } from 'src/client/components/ui/NavOrExternalLink';
import FavoriteButton from '../FavoriteButton/FavoriteButton';
import { useSelector } from '../../redux/modules/helpers/useSelector';
import { Photographer } from 'src/@types/Photographer';
import { useGetGalleryCoverUrl } from 'src/client/helpers/urls/useGetGalleryCoverUrl';

type Props = {
  photographer: Photographer;
  className?: string;
};

export const PhotographerDetailsPanel = (props: Props) => {
  const contentCdnUrl = useSelector((state) => state.app.contentCdnUrl);
  const config = useSelector((state) => state.app.config);

  const { photographer } = props;
  const { UUID, path, name, moviesCount, galleriesCount } = photographer;

  const getGalleryCover = useGetGalleryCoverUrl();
  const cover = getGalleryCover(contentCdnUrl, photographer, {
    clean: config.cleanGalleryCovers,
    thumbnail: true,
    scrapeUUID: true,
  });
  const largeCoverUrl = getGalleryCover(contentCdnUrl, photographer, {
    scrapeUUID: true,
  }).url;

  const { favoriteCount } = photographer;

  const badges = [
    ...(moviesCount > 0 ? [<Badge key="movies" text={moviesCount} icon={<FontAwesomeIcon icon={faFilm} />} />] : []),
    ...(galleriesCount > 0
      ? [<Badge key="images" text={galleriesCount} icon={<FontAwesomeIcon icon={faImages} />} />]
      : []),
  ];

  return (
    <PhotographerImageDetailsPanel
      isBlurred={cover.blurImage}
      imgSrc={cover.url}
      imgAlt={name}
      largeImageSrc={largeCoverUrl}
      className={props.className}
    >
      <PanelHeadline>
        <NavOrExternalLink to={path}>{name}</NavOrExternalLink>
      </PanelHeadline>

      <FavoriteButton favoriteCount={favoriteCount} objectType="PHOTOGRAPHER" objectUUID={UUID} />
      {badges.length > 0 && <StyledBadges>{badges}</StyledBadges>}
    </PhotographerImageDetailsPanel>
  );
};

const PhotographerImageDetailsPanel = styled(ImageDetailsPanel)`
  img {
    margin-bottom: 0;
    margin-right: 20px;
    max-width: 100px;
  }

  .name {
    &.visited,
    :active,
    :hover {
      text-decoration: none;
    }
  }
`;

const StyledBadges = styled(Badges)`
  margin-top: 10px;
`;
